import { useLocation } from "react-router-dom"

export const NoMatch = () => {
  const location = useLocation()

  return <div>Sorry, the page {location.pathname} does not exist.</div>
}
